import styled from '@emotion/styled'
import { AvatarImage } from '@radix-ui/react-avatar'

export const StyledAvatarImage = styled(AvatarImage)`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
`
